module.exports = __webpack_public_path__ + "img/helmet_visitor.d6f46064.png";